



















































import { Component, Vue } from 'vue-property-decorator';
import URI from 'urijs';
import Hit from '@/components/Hit.vue';

@Component({
  components: { Hit },
})
export default class ForYou extends Vue {
  private total: number = 0;
  private hits: object[] = [];

  private locating: boolean = true;
  private loading: boolean = true;
  private error: any = null;

  public fetch(): void {
    this.loading = true;
    this.locating = true;
    this.error = null;

    this.$getLocation().then((coords: any) => {
      this.locating = false;

      const url = new URI('https://alerts.zacharyseguin.ca/api/alerts/active');

      url.setQuery('language', 'en-*');
      url.setQuery('status', 'actual');
      url.setQuery('sort', '-effective');
      // url.setQuery('system', 'naads');
      url.setQuery('count', '10');
      // tslint:disable-next-line:max-line-length
      url.setQuery('fields', 'system,headline,senderName,effective,expires,urgency,severity,certainty,responseTypes,areas.description');
      url.setQuery('point', `${coords.lat},${coords.lng}`);

      fetch(url.toString())
        .then((r) => r.json())
        .then((r) => {
          this.total = parseInt(r.total, 10);
          this.hits = r.hits;

          this.loading = false;
        });
    }, (err: string) => {
      console.log(err);
      this.loading = false;
      this.locating = false;

      if (err === "no position access") {
        this.error = "Permission to access your location is required to show personalized alerts.";
      } else {
        this.error = "Unable to find your location.";
      }
    });
  }

  public mounted(): void {
    this.fetch();
  }
}
